import { compose, applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';

import { reducer as localeReducer } from './features/locale';
import { reducer as authReducer } from './features/Auth';
import { reducer as notifyReducer } from './features/notify';
import { reducer as users } from './features/users/redux';
import { reducer as treeReducer } from './features/tree';
import { reducer as reports } from './features/reports/redux';
import { reducer as finance } from './features/finance';
import { reducer as userSettings } from './features/userSettings';
import { reducer as sportHistory } from './features/sportHistory';
import { reducer as statistic } from './features/statistic';
import { reducer as rankings } from './features/ranking';
import { reducer as bonusProgram } from './features/bonusProgram';
import { reducer as cashback } from './features/cashback';
import { reducer as creativeFunctionality } from './features/creativeFunctionality';
import { reducer as agentFeedback } from './features/AgentFeedback';
import { reducer as casinoReducer } from './features/casino';
import { reducer as assistantReducer } from './features/assistant';
import { reducer as betsLimitsReducer } from './features/betsLimits';
import { reducer as domainsReducer } from './features/domains';
import { reducer as surveyReducer } from './features/survey';

function configureStore(extra) {
  const middlewares = [thunk.withExtraArgument(extra)];

  const reducer = createReducer();

  // TODO: отключить devtools в production
  const store = createStore(
    reducer,
    compose(
      applyMiddleware(...middlewares),
      persistState(['userSettings', 'auth']),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true }) : arg => arg,
    ),
  );

  return store;
}

function createReducer() {
  return combineReducers({
    locale: localeReducer,
    auth: authReducer,
    notify: notifyReducer,
    users: users,
    tree: treeReducer,
    reports: reports,
    finance: finance,
    creativeFunctionality,
    sportHistory,
    userSettings,
    statistic,
    rankings,
    bonusProgram,
    cashback,
    agentFeedback,
    casino: casinoReducer,
    betsLimits: betsLimitsReducer,
    assistant: assistantReducer,
    domains: domainsReducer,
    survey: surveyReducer,
  });
}

export { createReducer };
export default configureStore;
